__turbopack_context__.v({
  "active": "styles-module__Neg9EW__active",
  "adminTaskContainer": "styles-module__Neg9EW__adminTaskContainer",
  "buttons": "styles-module__Neg9EW__buttons",
  "circle": "styles-module__Neg9EW__circle",
  "img": "styles-module__Neg9EW__img",
  "imgAnimate": "styles-module__Neg9EW__imgAnimate",
  "listTask": "styles-module__Neg9EW__listTask",
  "listTask2": "styles-module__Neg9EW__listTask2",
  "listTask3": "styles-module__Neg9EW__listTask3",
  "taskActive": "styles-module__Neg9EW__taskActive",
  "taskDesc": "styles-module__Neg9EW__taskDesc",
  "taskItem": "styles-module__Neg9EW__taskItem",
  "taskTitle": "styles-module__Neg9EW__taskTitle",
  "title": "styles-module__Neg9EW__title",
});
